export interface BriefingPack {
  childName: string
  snapshot: string
  strengths: BriefingItem[]
  challenges: BriefingItem[]
  whatHelps: BriefingItem[]
  whatMakesWorse: BriefingItem[]
  fitCheck: string[]
  interviewGuidance: {
    questions: string[]
    checklist: string[]
  }
}

export interface BriefingItem {
  content: string
  source: 'report' | 'parent'
}

export interface ParentInput {
  childName: string
  comeAlive: string
  additionalNotes: string
}

export type AppStep = 'landing' | 'consent' | 'upload' | 'review' | 'complete'

// Cookbook types
export interface CookbookQuestionnaire {
  // Section 1: Meal preferences
  likedMeals: string[]
  includeLikedMeals: boolean
  wantNewIdeas: boolean
  mealNotes: string

  // Section 2: Food likes/dislikes
  fish: string[]
  fishNotes: string
  seafood: string[]
  seafoodNotes: string
  meat: string[]
  meatNotes: string
  eggs: string[]
  eggNotes: string
  plantProteins: string[]
  plantProteinNotes: string
  flavourStrength: string
  flavourNotes: string
  spices: string
  spiceNotes: string
  herbs: string
  herbNotes: string
  textures: string[]
  textureNotes: string
  strongDislikes: string[]
  dislikeNotes: string
  carbs: string[]
  carbNotes: string
  mealStyles: string[]
  mealStyleNotes: string
  packedLunch: boolean
  packedLunchNotes: string
  afterSchoolSnacks: boolean
  childrenHelpCook: string
  cookingHelpNotes: string

  // Section 3: Allergies & dietary
  allergies: string[]
  otherAllergies: string
  dietaryRequirements: string[]
  medicalRequirements: string
  dietaryNotes: string

  // Section 4: Nutritional preferences
  nutritionalRanking: { [key: string]: number }
  nutritionalNotes: string
  pudding: string
  puddingNotes: string
  familyFoodRules: string

  // Section 5: Household constraints
  dinnerTime: string
  cookingDuration: string
  nannyConfidence: string
  nannyConfidenceNotes: string
  nannyExpectations: string[]
  nannyExpectationNotes: string
  batchCook: string
  batchCookNotes: string
  weekdayDinners: string
  leftovers: string
  leftoverNotes: string
  appliances: string[]
  otherAppliances: string

  // Contact & Family Info
  email: string
  familyName: string
  childrenNames: string
  childrenAges: string
}

export type CookbookStep =
  | 'landing'
  | 'consent'
  | 'questionnaire'
  | 'submitted'
  | 'error'

export const EMPTY_COOKBOOK_QUESTIONNAIRE: CookbookQuestionnaire = {
  likedMeals: [],
  includeLikedMeals: true,
  wantNewIdeas: true,
  mealNotes: '',
  fish: [],
  fishNotes: '',
  seafood: [],
  seafoodNotes: '',
  meat: [],
  meatNotes: '',
  eggs: [],
  eggNotes: '',
  plantProteins: [],
  plantProteinNotes: '',
  flavourStrength: '',
  flavourNotes: '',
  spices: '',
  spiceNotes: '',
  herbs: '',
  herbNotes: '',
  textures: [],
  textureNotes: '',
  strongDislikes: [],
  dislikeNotes: '',
  carbs: [],
  carbNotes: '',
  mealStyles: [],
  mealStyleNotes: '',
  packedLunch: false,
  packedLunchNotes: '',
  afterSchoolSnacks: false,
  childrenHelpCook: '',
  cookingHelpNotes: '',
  allergies: [],
  otherAllergies: '',
  dietaryRequirements: [],
  medicalRequirements: '',
  dietaryNotes: '',
  nutritionalRanking: {},
  nutritionalNotes: '',
  pudding: '',
  puddingNotes: '',
  familyFoodRules: '',
  dinnerTime: '',
  cookingDuration: '',
  nannyConfidence: '',
  nannyConfidenceNotes: '',
  nannyExpectations: [],
  nannyExpectationNotes: '',
  batchCook: '',
  batchCookNotes: '',
  weekdayDinners: '',
  leftovers: '',
  leftoverNotes: '',
  appliances: [],
  otherAppliances: '',
  email: '',
  familyName: '',
  childrenNames: '',
  childrenAges: ''
}
